<template>
  <div class="apple-page">
    <!-- Hero -->
    <section class="apple-hero">
      <headerPage :current="0"></headerPage>
      <el-carousel class="apple-hero__carousel" height="min(50vh, 560px)" :interval="5000">
        <el-carousel-item v-for="item in swiperList" :key="item.id">
          <img class="apple-hero__img" :src="item.img" alt="" />
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- About Us -->
    <section class="apple-section apple-section--light">
      <div class="apple-container">
        <h2 class="apple-section__eyebrow">About Us</h2>
        <h3 class="apple-section__title">企业简介</h3>
        <div class="apple-about">
          <div
            class="apple-about__media apple-img-bg"
            :style="{ backgroundImage: 'url(' + aboutBg + ')' }"
          ></div>
          <div class="apple-about__content">
            <h4 class="apple-about__heading">企业背景</h4>
            <p class="apple-about__text">
              公司注册地为北京，公司具备自主知识产权的全套医疗卫生解决方案（HIS、EMR、LIS、PACS、移动诊疗）、国家全民健康系统、金融系统开发方案，是一家集行业解决方案设计、大型行业应用软硬件开发、系统集成与服务、咨询规划和教育培训于一体的综合性智能型密集的科技企业，业务范围覆盖了政府、医疗卫生、金融等众多行业领域。
            </p>
            <a href="#" class="apple-cta apple-cta--primary" @click.prevent="$router.push({ name: 'about' })">进一步了解</a>
          </div>
        </div>
      </div>
    </section>

    <template v-if="lazyLoading">
      <!-- Values Section - 科技感区块 -->
      <section class="apple-section apple-section--tech">
        <div class="apple-values">
          <div class="apple-values__intro">
            <img class="apple-values__icon" src="@/assets/11111.png" alt="" />
            <h4 class="apple-values__title">以人为本</h4>
            <p class="apple-values__desc">
              秉持"健康为先，服务至上"的核心价值观，我们视每位用户的健康需求为事业的首要考量，构建完善的健康档案系统、个性化定制的健康解决方案，致力于通过科技创新改善人们的健康状况。
            </p>
          </div>
          <div class="apple-values__cards">
            <div
              v-for="(item, index) in loopData0"
              :key="index"
              class="apple-card apple-card--feature apple-img-bg"
              :style="{ backgroundImage: 'url(' + item.lanhuBg0 + ')' }"
            >
              <div class="apple-card__overlay"></div>
              <span class="apple-card__title">{{ item.lanhutext0 }}</span>
              <a href="#" class="apple-cta apple-cta--light" @click.prevent="$router.push({ name: 'product' })">进一步了解</a>
            </div>
          </div>
        </div>
      </section>

      <!-- Team Section -->
      <section class="apple-section apple-section--light">
        <div class="apple-container">
          <h2 class="apple-section__eyebrow">Professional Team</h2>
          <h3 class="apple-section__title">专业的团队</h3>
          <div class="apple-team">
            <div class="apple-team__card apple-team__card--image apple-img-bg" :style="{ backgroundImage: 'url(' + teamImg1 + ')' }"></div>
            <div class="apple-team__card apple-team__card--text">
              <h4>团队成员</h4>
              <p>团队成员有来自中科院、清华、北航、北京理工等院校毕业的优秀研发人员，同时也融合了来自IBM、朗讯、中科软等国内外知名公司的技术骨干，集结了健康设备研发、健康管理、数据分析、人工智能等多个领域的专家。</p>
            </div>
            <div class="apple-team__card apple-team__card--image apple-img-bg" :style="{ backgroundImage: 'url(' + teamImg2 + ')' }"></div>
            <div class="apple-team__card apple-team__card--text">
              <h4>团队风貌</h4>
              <p>我们不仅是一家健康科技公司，更是由梦想家、创新者和变革推动者组成的大家庭，我们深信，科技的力量在于改善生活、增进健康。因此"以人为本，科技创新"不仅是团队的口号，更是每位团队成员心中的灯塔。</p>
            </div>
            <div class="apple-team__card apple-team__card--image apple-img-bg" :style="{ backgroundImage: 'url(' + teamImg3 + ')' }"></div>
            <div class="apple-team__card apple-team__card--text">
              <h4>团队精神</h4>
              <p>用专业成就客户体验，用周到细节传递温暖，用价值赋能延续相伴。</p>
            </div>
          </div>
        </div>
      </section>

      <footerPage></footerPage>
    </template>
  </div>
</template>

<script>
import headerPage from "@/components/HeadrPage.vue";
import footerPage from "@/components/footerPage.vue";
import heroBanner from "@/assets/lunbo.png";
import img_4 from "@/assets/img_4.png";
import img_5 from "@/assets/img_5.png";
import img_7 from "@/assets/img_7.png";
import img_10 from "@/assets/img_10.png";
import img_11 from "@/assets/img_11.png";
import img_15 from "@/assets/img_15.png";
import img_16 from "@/assets/img_16.png";
import img_17 from "@/assets/img_17.png";

export default {
  components: { headerPage, footerPage },
  data() {
    return {
      aboutBg: img_11,
      teamImg1: img_15,
      teamImg2: img_16,
      teamImg3: img_17,
      swiperList: [{ img: heroBanner, id: 0 }],
      loopData0: [
        { lanhuBg0: img_4, lanhutext0: "科技创新", lanhutext1: "more" },
        { lanhuBg0: img_5, lanhutext0: "诚信经营", lanhutext1: "more" },
        { lanhuBg0: img_7, lanhutext0: "合作共赢", lanhutext1: "more" },
      ],
      lazyLoading: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.lazyLoading = true;
    }, 800);
  },
};
</script>

<style scoped>
.apple-page {
  background: var(--apple-white);
}

/* 平滑变换 - 硬件加速 */
.apple-about__media,
.apple-card,
.apple-team__card,
.apple-values__intro {
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

/* Hero - 与软件下载 top 图片尺寸一致 */
.apple-hero {
  position: relative;
  min-height: 50vh;
  max-height: 560px;
  overflow: hidden;
}

.apple-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.15) 0%, transparent 30%, transparent 70%, rgba(251,251,253,0.5) 100%);
  pointer-events: none;
  z-index: 1;
}

.apple-hero::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(to top, rgba(251, 251, 253, 0.6), transparent);
  pointer-events: none;
  z-index: 1;
}

.apple-hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.apple-hero:hover .apple-hero__img {
  transform: scale(1.03);
}

/* Override Element carousel - 与软件下载 apple-banner 一致 */
.apple-hero ::v-deep .el-carousel__container {
  height: 100%;
}

.apple-hero ::v-deep .el-carousel__indicators {
  bottom: 24px;
}

.apple-hero ::v-deep .el-carousel__indicator {
  padding: 8px 4px;
}

.apple-hero ::v-deep .el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  opacity: 1;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), background 0.2s ease;
}

.apple-hero ::v-deep .el-carousel__indicator:hover .el-carousel__button {
  background: rgba(255, 255, 255, 0.8);
}

.apple-hero ::v-deep .el-carousel__indicator:active .el-carousel__button {
  transform: scale(0.85);
}

.apple-hero ::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 0.95);
  width: 24px;
  border-radius: 4px;
}

/* Sections */
.apple-section {
  padding: var(--space-3xl) 22px;
}

.apple-section + .apple-section {
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.apple-section--light {
  background: var(--apple-white);
}

.apple-section--tech {
  background: var(--apple-bg);
  position: relative;
}

.apple-section--tech::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(0, 113, 227, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 113, 227, 0.02) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
}

.apple-container {
  max-width: 980px;
  margin: 0 auto;
}

.apple-section__eyebrow {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #06c;
  margin: 0 0 8px;
}

.apple-section__title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--apple-black);
  margin: 0 0 48px;
}

/* About */
.apple-about {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

.apple-about__media {
  aspect-ratio: 4/3;
  background-size: cover;
  background-position: center;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: transform var(--transition-smooth), box-shadow var(--transition-smooth);
}

.apple-about__media:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: var(--shadow-float);
}

.apple-about__heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--apple-black);
  margin: 0 0 16px;
}

.apple-about__text {
  font-size: 15px;
  line-height: 1.6;
  color: var(--apple-dark-gray);
  margin: 0 0 24px;
}

.apple-about__content .apple-cta {
  margin-bottom: 0;
}

/* Values */
.apple-values {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 24px;
  align-items: stretch;
  position: relative;
  z-index: 1;
}

.apple-values__intro {
  flex: 0 0 380px;
  padding: 40px;
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card), var(--shadow-inner);
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
  transition: transform var(--transition-smooth), box-shadow var(--transition-smooth);
}

.apple-values__intro:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md), var(--shadow-inner);
}

.apple-values__icon {
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
}

.apple-values__title {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--apple-black);
  margin: 0 0 16px;
}

.apple-values__desc {
  font-size: 15px;
  line-height: 1.6;
  color: var(--apple-dark-gray);
  margin: 0;
}

.apple-values__cards {
  flex: 1;
  display: flex;
  gap: 24px;
}

.apple-card {
  flex: 1;
  min-height: 320px;
  padding: 32px 24px;
  background-size: cover;
  background-position: center;
  border-radius: var(--radius-xl);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: transform var(--transition-float), box-shadow var(--transition-smooth), filter var(--transition-smooth);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: var(--shadow-card);
  z-index: 1;
}

.apple-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: var(--shadow-float);
  filter: brightness(1.05) saturate(0.95) contrast(1.02);
}

.apple-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 20%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.6) 100%);
  pointer-events: none;
  transition: opacity var(--transition-smooth);
}

.apple-card__title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--apple-white);
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 1;
}

.apple-cta {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  margin-top: 12px;
  padding: 10px 20px;
  border-radius: var(--radius-md);
  transition: transform var(--transition-fast), opacity var(--transition-fast),
    box-shadow var(--transition-fast), background var(--transition-fast);
  position: relative;
  z-index: 1;
}

.apple-cta:hover {
  opacity: 0.9;
}

.apple-cta:active {
  transform: scale(0.96);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.apple-cta--primary {
  color: #06c;
  background: rgba(0, 102, 204, 0.06);
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.12);
}

.apple-cta--primary:hover {
  background: rgba(0, 102, 204, 0.1);
  box-shadow: 0 4px 16px rgba(0, 102, 204, 0.15);
}

.apple-cta--primary:active {
  box-shadow: 0 1px 4px rgba(0, 102, 204, 0.2);
}

.apple-cta--light {
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.apple-cta--light:hover {
  background: rgba(255, 255, 255, 0.22);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.apple-cta--light:active {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
  background: rgba(255, 255, 255, 0.12);
}

/* Team */
.apple-team {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.apple-team__card {
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: transform var(--transition-float), box-shadow var(--transition-smooth);
}

.apple-team__card:hover {
  transform: translateY(-6px);
}

.apple-team__card--image {
  min-height: 200px;
  background-size: cover;
  background-position: center;
  box-shadow: var(--shadow-card);
}

.apple-team__card--image:hover {
  box-shadow: var(--shadow-md);
}

.apple-team__card--text {
  padding: 28px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: var(--shadow-sm);
}

.apple-team__card--text h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--apple-black);
  margin: 0 0 12px;
}

.apple-team__card--text p {
  font-size: 14px;
  line-height: 1.6;
  color: var(--apple-dark-gray);
  margin: 0;
}

@media (max-width: 1068px) {
  .apple-about {
    grid-template-columns: 1fr;
  }

  .apple-values {
    flex-direction: column;
  }

  .apple-values__intro {
    flex: none;
  }

  .apple-values__cards {
    flex-direction: column;
  }

  .apple-team {
    grid-template-columns: 1fr;
  }
}
</style>
